import { CardContentComponent } from "./card-content";
import { CardFolderComponent } from "./card-folder";
import { CardHeaderComponent } from "./card-header";
import { IconContainerComponent } from "./icon-container";
import { ImgContainerComponent } from "./img-container";
import { SectionHeaderComponent } from "./section-header";

export * from "./icon-container";
export * from "./img-container";
export * from "./card-header";
export * from "./card-folder";
export * from "./card-content";
export * from "./section-header";

export const CardAtoms = [
  ImgContainerComponent,
  IconContainerComponent,
  CardFolderComponent,
  CardContentComponent,
  CardHeaderComponent,
  SectionHeaderComponent
];
